exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".UsersTable_displayName__3cq6x {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-align-items: center;\n          align-items: center; }\n  .UsersTable_displayName__3cq6x .UsersTable_avatar__yNzY9 {\n    margin-right: 10px; }\n", ""]);

// exports
exports.locals = {
	"displayName": "UsersTable_displayName__3cq6x",
	"avatar": "UsersTable_avatar__yNzY9"
};